import { render, staticRenderFns } from "./File_show.vue?vue&type=template&id=c45b3b64&scoped=true&"
import script from "./File_show.vue?vue&type=script&lang=js&"
export * from "./File_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45b3b64",
  null
  
)

export default component.exports